import { render } from "./EditModal.vue?vue&type=template&id=22e1e2bc&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"

import "./EditModal.vue?vue&type=style&index=0&id=22e1e2bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e1e2bc"]])

export default __exports__